import React from 'react';

const AmexIcon: React.FC<{className?: string}> = ({ className = "w-12 h-8" }) => (
  <svg className={className} viewBox="0 0 48 32" fill="none">
    <rect width="48" height="32" rx="4" fill="#2E77BB"/>
    <text x="24" y="21" textAnchor="middle" fontWeight="bold" fontSize="12" fill="white" fontFamily="Arial">AMEX</text>
  </svg>
);

export default AmexIcon; 